export const FORM_FILE_DATA_KEY = "file";

export const FORM_JSON_DATA_KEY = "json";
